import { useEffect } from "react"
import { Homeheader, Grid, GetALoan, FrequentQuestion, ScrollTab } from "../components"
import { Navbar, Footer } from "../layouts"




const LoanPage = () => {

    useEffect(() => {
        window.scrollTo({
            top: 0, 
            behavior: 'smooth'
          });
    }, [])

    return (
        <>
        <Navbar/>
        <Grid/> 
        <Homeheader/>
        <ScrollTab/>
        <GetALoan/>
        <FrequentQuestion displaySeeMore={false}/>
        <Footer/>
        </>

    )
}

export default LoanPage